var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blueprint-wrapper',[_c('blueprint-header',[_c('job-request-header'),_c('div',{staticClass:"SPACER"}),_c('job-request-info-heading'),_c('job-request-navigation')],1),_c('blueprint-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('blueprint-footer',[_c('footer-lower')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }